export const USDC_MINT = "Raisg93hadrPtL4YG49JyZeT4KACJg1T7gB7sPpdNUe";
// export const URL_MARKETS = "https://testnet-api.raiserdapp.com";
export const URL_MARKETS = "https://testnet-api-internal.raiserdapp.com";
export const PROGRAM_DEX = "FbrRHz6bgX9khQNpzKJJuTWk1Hn4PSkG1B8cTyuP1jf1";

export const CREDORA_CLIENTID = "Uq7hGEsrXE9lrRFDuYzMA1PYx"

export const CREODORA_CLIENTSECRET = "1Ay567Hd17US9AdKQNaExEXSB"
